const config = require("./config.js");

let context = new AuthenticationContext({
    tenant: "cubesmart.onmicrosoft.com",
    clientId: config.AdalClientID,
    cacheLocation: 'localStorage'
});

const Authenticator = {
    CheckForHashToken() {
        var hash = window.location.hash;

        if (hash.length > 1) {
            var vals = window.location.hash.slice(1).split("&");

            if (vals.length) {
                var token = vals.filter(function whereToken(pair) {
                    return pair.match(/id_token=/);
                });

                if (token.length) {
                    context.handleWindowCallback(); // This will reload the window.

                    return true;
                }
            }
        }

        return false;
    },
    WithToken: function (tokenCallback, errorCallback) {
        context.acquireToken(config.AdalClientID,
            function tokenAcquired(message, token) {
                if (message) {
                    if (errorCallback) {
                        return errorCallback(message);
                    }
                    else {
                        return context.login();
                    }
                }
                else {
                    return tokenCallback(token);
                }
            });
    },
    LoadToken: function (autoLogin) {
        var promise = new Promise(function resolveTokenPromise(resolve, reject) {
            context.acquireToken(config.AdalClientID,
                function acquired(message, token) {
                    if (message) {
                        if (autoLogin) {
                            context.login();
                        }

                        reject(message);
                    }
                    else {
                        resolve(token);
                    }
                });
        });

        return promise;
    },
    GetToken() {
        var token = sessionStorage[context.CONSTANTS.STORAGE.IDTOKEN];

        return token;
    },
    LogIn() {
        context.login();
    },
    LogOut() {
        context.logOut();
    }
};

module.exports = Authenticator;


// WEBPACK FOOTER //
// ./src/authenticator.js